import { Box, CircularProgress, Stack, Typography, useTheme } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import AiMessage from '../AiMessage';
import { useAskAIContext } from '@/context/AskAiContext';

const MessagesContainer = () => {
	const { messages, isBusy } = useAskAIContext();
	const theme = useTheme();

	const messagesEndRef = useRef(null);

	useEffect(() => {
		const end = messagesEndRef.current;
		if (!end) return;

		requestAnimationFrame(() => {
			end.scrollIntoView({
				behavior: messages.length > 1 ? 'smooth' : 'auto',
				block: 'end',
			});
		});
	}, [messages, isBusy]);

	return (
		<Stack spacing={3.25}>
			{messages.map((message, index) => (
				<AiMessage
					key={message.id ?? message.messageId ?? `ai-message-${index}`}
					message={message}
				/>
			))}

			{isBusy && messages.length > 0 && (
				<Stack direction='row' spacing={1.2} alignItems='center' sx={{ px: 0.5 }}>
					<CircularProgress size={18} />
					<Typography variant='body2' sx={{ color: theme.palette.text.secondary }}>
						Folio AI is thinking through the current context...
					</Typography>
				</Stack>
			)}

			<Box ref={messagesEndRef} sx={{ height: 1 }} />
		</Stack>
	);
};

export default MessagesContainer;
